import Vue from 'vue'
import notification from 'ant-design-vue/lib/notification'
import moment from 'moment'

// 角色id转Name
const getRoleName = function (roleId) {
  if (!roleId) {
    return ''
  }
  let name = ''
  switch (Number(roleId)) {
    case 1:
      name = '参观商'
      break
    case 2:
      name = '主办商'
      break
    case 3:
      name = '参展商'
      break
    case 4:
      name = '展厅工程商'
      break
    case 5:
      name = '设计师'
      break
    default:
      name = ' '
      break
  }
  return name
}

// 查看更多
const showMore = function (item) {
  let path = false
  // console.log('item.datamoduleId', item)
  switch (item.datamoduleId) {
    case 2:
      switch (item.datamodulesubId) {
        case 201:
        case 202:
          path = '/showroom/designer'
          break
        case 203:
          path = '/showroom/build'
          break
        case 206:
          path = '/company-cloud'
          break
      }
      break
    case 3:
      item.datamodulesubId === 301 ? (path = '/cloudexhibition') : (path = '/exhibition')
      break
    case 4:
      item.datamodulesubId === 402 ? (path = '/meeting?chinaFlag=1') : (path = '/meeting?chinaFlag=2')
      break
    case 5:
      path = '/showroom/model'
      break
    case 6:
      path = '/news'
      break
    case 7:
      path = '/live'
      break
    case 8:
      path = '/poster'
      break
    case 10:
      path = '/product'
      break
    // case 12:
    // 3D页, 已弃用
    //   path = '/threed'
    //   break
  }
  return path
}

/**
 * 首页运营位信息
 * 1 - 用户模块
 *    101 - 名片模块
 * 2 - 企业模块
 *    201 - 模型设计师
 *    202 - 海报设计师
 *    203 - 展台搭建工程商
 * 3 - 展览模块
 *    301 - 云上模块
 *    302 - 国内
 *    303 - 国外
 *    304 - 线下
 * 4 - 会议
 *    401 - 云上
 *    402 - 国内
 *    403 - 国外
 * 5 - 模型
 * 6 - 资讯
 * 7 - 直播
 * 8 - 海报设计
 * 9 - 首页
 * 10 - 产品模块
 * 12 - 3D模块
 * 13 - 招标模块
 */
const switchSlotName = (item) => {
  let comp
  // console.log('item', item, item.datamodulesubId)
  switch (item.datamoduleId) {
    case 1:
      comp = 'vCard'
      break
    case 2:
      item.datamodulesubId === 206 ? (comp = 'vCloudSystem') : (comp = 'vEngineer')
      break
    case 3:
      item.datamodulesubId === 301 ? (comp = 'vCloudExpo') : (comp = 'vDownExpo')
      break
    case 4:
      comp = 'vMeeting'
      break
    case 5:
      comp = 'vRoomMake'
      break
    case 6:
      comp = 'vInfo'
      break
    case 7:
      comp = 'vLive'
      break
    case 8:
      comp = 'vPoster'
      break
    // case 9:
    //   comp = ''
    //   break
    case 10:
      comp = 'vShop'
      break
    // case 11:
    //   comp = ''
    //   break
    case 12:
      comp = 'vThreeDList'
      break
    case 13:
      comp = 'vBiding'
      break
  }
  return comp
}

// 阿拉伯数字转中文数字
const toChinesNum = (num) => {
  if (!num) {
    return ''
  }
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  const intNum = parseInt(num, 10)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (let i = 0; i < strArr.length; i++) {
      newNum =
        (i === 0 && strArr[i] === 0
          ? ''
          : i > 0 && strArr[i] === 0 && strArr[i - 1] === 0
            ? ''
            : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i])) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(intNum / 10000)
  let noWan = intNum % 10000
  if (noWan.toString().length < 4) {
    noWan = `0${noWan}`
  }
  return overWan ? `${getWan(overWan)}万${getWan(noWan)}` : getWan(intNum)
}

// 判断当前时间是否大于开幕时间,返回开幕类型或闭幕类型
const isOpening = (beginTime) => {
  const flag = moment().isBefore(beginTime)
  return flag ? '开幕' : '闭幕'
}
// 图片转Base64
const getBase64 = (img, callback) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
/**
 * base64图片转文件类型
 * @param {*} dataurl base64
 * @param {*} filename 文件名称
 * @param {*} isIE 是否ie浏览器 默认不是
 */
const dataURLtoFile = (dataurl, filename, isIE = false) => {
  // console.log('dataURLtoFile-dataurl', dataurl)
  // 将base64转换为文件
  const arr = dataurl.split(',')
  // console.log('dataURLtoFile-arr[0]', arr[0])
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  // console.log('dataURLtoFile-bstr', bstr)
  let n = bstr.length
  // console.log('dataURLtoFile-n', n)
  const u8arr = new Uint8Array(n)
  // console.log('dataURLtoFile-u8arr', u8arr)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  console.log('isIE', isIE)
  let file = ''
  if (isIE) {
    file = new Object([u8arr], filename, { type: mime })
    // const data = new FormData()
    // data.append('file', dataurl, filename)
    // file = data
  } else {
    file = new File([u8arr], filename, { type: mime })
  }
  return file
}

// 数字千分位转换
const numberFormatter = (num) =>
  num.toString().includes('.') ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
//  `${num}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
// 跳转外链
const toOuterLink = (url, newWindow = true) => {
  if (!url) {
    return ''
  }
  console.log('toOuterLink', url, location)

  // const protocol = window.location.protocol
  const protocol = 'http:'
  console.log('protocol', protocol)

  let jumpUrl = url

  // 如果是跳同一域名的
  if (url.substr(0, 1) === '/') {
    jumpUrl = location.host + url
  }
  if (!(url.includes('http') || url.includes('https'))) {
    jumpUrl = `${protocol}//${jumpUrl}`
    console.log('toOuterLink-add', url)
  }

  if (newWindow) {
    window.open(jumpUrl)
  } else {
    window.location.href = jumpUrl
  }
}
// 新开页签跳转内链
const toInsideLink = (url) => {
  window.open(url)
}
Vue.prototype.$utils = {
  getRoleName,
  toChinesNum,
  isOpening,
  getBase64,
  numberFormatter,
  toOuterLink,
  toInsideLink,
  dataURLtoFile,
  showMore,
  switchSlotName,
}

// 如果不是请求后端的接口,导致进入else分支的情况下使用
Vue.prototype.$ClientError = () => {
  // TODO 增加反馈系统表单
  notification.error({
    title: '提示',
    message: window.location.hostname.includes('en')
      ? '客户端错误,请联系网站管理员'
      : 'Client error, please contact the website administrator',
  })
}
Vue.prototype.$serverError = () => {
  // TODO 增加反馈系统表单
  notification.error({
    title: '提示',
    message: window.location.hostname.includes('en')
      ? 'Server error, please try again later'
      : '服务器出小差,请稍候再试',
  })
}
